export default "__VITE_ASSET__1IOjeUn8__"